export const GET_LOCATIONS_LIST_DATA_AND_LOADING = "GET_LOCATIONS_LIST_DATA_AND_LOADING"
export const EXPORT_LOCATION_LIST_LOADING = "EXPORT_LOCATION_LIST_LOADING"
export const IMPORT_LOCATIONS_FILE_LOADING = "IMPORT_LOCATIONS_FILE_LOADING"
